import {IAccountant} from "api/types";
import {FC} from "react";
import SkillGroupsBreakdown from "./SkillGroupsBreakdown";
import GroupComparison from "./GroupComparison";
import LifetimeSkillChart from "./LifetimeSkillChart/LifetimeSkillChart";
import RecentTrainingActivity from "./RecentTrainingActivity";
import FoundationalKnowledge from "./FoundationalKnowledge";

interface Props {
  user: IAccountant;
  isPaidMember: boolean;
  onSubscribe: () => void;
  activeTab: "applied" | "foundational";
  setActiveTab: (tab: "applied" | "foundational") => void;
}

const ProfileTabs: FC<Props> = ({user, isPaidMember, onSubscribe, activeTab, setActiveTab}) => (
  <div>
    <div className="flex items-end" style={{position: "relative", zIndex: 1}}>
      {(["applied", "foundational"] as const).map((tab) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className="flex-1 px-6 py-3 text-sm transition-all relative"
            style={{
              backgroundColor: isActive ? "white" : "#EDE9E3",
              color: isActive ? "#3D52AD" : "#8490AA",
              fontWeight: isActive ? 700 : 500,
              border: "1px solid #E8E4DF",
              borderBottom: isActive ? "1px solid white" : "1px solid #E8E4DF",
              borderRadius: "12px 12px 0 0",
              marginBottom: isActive ? "-1px" : "0",
              marginRight: "2px",
            }}
          >
            {tab === "applied" ? "Applied Skills" : "Foundational Knowledge"}
          </button>
        );
      })}
    </div>

    <div className="rounded-b-2xl rounded-tr-2xl border border-brand-border bg-white p-6">
      <div style={{display: activeTab === "applied" ? "block" : "none"}}>
        <AppliedSkillsTab user={user} isPaidMember={isPaidMember} onSubscribe={onSubscribe} />
      </div>
      <div style={{display: activeTab === "foundational" ? "block" : "none"}}>
        <FoundationalKnowledge />
      </div>
    </div>
  </div>
);

interface AppliedSkillsTabProps {
  user: IAccountant;
  isPaidMember: boolean;
  onSubscribe: () => void;
}

const AppliedSkillsTab: FC<AppliedSkillsTabProps> = ({user, isPaidMember, onSubscribe}) => {
  return (
    <div className="relative">
      {!isPaidMember && !user.enterprise && (
        <div className="absolute inset-0 backdrop-grayscale backdrop-blur-md flex items-start justify-center z-50 rounded-2xl p-10">
          <div className="bg-white rounded-2xl overflow-hidden flex flex-col h-max drop-shadow-xl border border-brand-border">
            <main className="flex flex-col p-6 items-center justify-center gap-2">
              <span className="text-xl font-semibold text-brand-navy">Paid Member Access Only</span>
              <span className="text-sm text-brand-navy text-left w-full">
                This section shows your skill stats if you're a paying member.
              </span>
              <span className="text-sm text-brand-navy text-left w-full">
                👈 Don't have a membership? No worries — click <b>Go to My Courses</b> above.
              </span>
              <span className="text-sm text-brand-navy text-center w-full mt-1">Want to see your stats?</span>
            </main>
            <footer className="p-4 flex items-center justify-center border-t border-brand-border">
              <button onClick={onSubscribe} className="btn-primary">
                Click Here To Purchase
              </button>
            </footer>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 2xl:grid-cols-4 gap-4">
        <SkillGroupsBreakdown user={user} />
        <GroupComparison user={user} />
        <LifetimeSkillChart user={user} />
        <RecentTrainingActivity user={user} />
      </div>
    </div>
  );
};

export default ProfileTabs;
